import { useEffect, useState } from 'react';

const useWidthFlags = () => {
  const { clientWidth: initialClientWidth } = document.documentElement;
  const [hideSideBar, setHideSideBar] = useState(initialClientWidth <= 599);
  const [showCwoLogoSmall, setShowCwoLogoSmall] = useState(initialClientWidth <= 599);
  const [dontShowCwoLogo, setDontShowCwoLogo] = useState(initialClientWidth <= 400);

  useEffect(() => {
    const handleResize = () => {
      const { clientWidth } = document.documentElement;

      setHideSideBar(clientWidth <= 599);
      setShowCwoLogoSmall(clientWidth <= 599);
      setDontShowCwoLogo(clientWidth <= 400);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    hideSideBar,
    showCwoLogoSmall,
    dontShowCwoLogo,
  };
};

export default useWidthFlags;
